import React, { useEffect } from 'react';
import './art70.css';
import { art70 } from '../../json/art70';


const Art70 = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

    return (
        <div className='container container_detalle_rubro'>
            <div className='row'>
                <div className='col-12'>
                    <div className='rubro_titulo'>
                        <h3 className='title'>Art. 70 Ley de Transparencia</h3>
                        <hr className='hr-gob' />
                    </div>
                </div>
            </div>
            <div className='row'>
                {
                    art70.map((item, index) => (
                        <div key={ index } className='col-md-4 col-12'>
                            <div className='rubro_container_detalle'>
                                <div className='detalle_rubro_nombre'>
                                    <h5>{ item.nombre }</h5>
                                </div>
                                <div className='detalle_rubro_enlaces'>
                                    <a href={ item.url } target="_blank">XLSX</a>
                                </div>
                            </div>
                        </div>
                    ))
                }
                <a className='rubros_historicos' href='../../RubrosHistoricos70'>Información histórica ejercicios anteriores Art. 70</a>
            </div>
        </div>
    );
};

export default Art70